<template>
    <div>
        <img src="../src/assets/projects/product.png" style="width: 100%; " />
    </div>
    <main class="container">
        <!-- 商品详情区域 -->
        <div class="product-detail">
            <div class="product-gallery">
                <div class="main-image" :style="{ backgroundImage: `url(${currentImage})` }"></div>
            </div>

            <div class="product-info">
                <h1 class="product-title">{{ product.name }}</h1>
                <p class="product-description">{{ product.description }}</p>

                <div class="product-price">
                    <span class="current-price">€ {{ product.price }}</span>
                </div>

                <div>
                    <div style=" margin: 20px 0;">Catégorie:&nbsp;<span style="font-weight:bold;">{{product.series}}</span></div>
                    <div style=" margin: 20px 0;">Spec:</div>
                </div>

                <div class="quantity-selector">
                    <span class="quantity-label">Quantity:</span>
                    <div class="quantity-controls">
                        <button class="quantity-btn" @click="decreaseQuantity">-</button>
                        <input type="number" class="quantity-input" v-model.number="quantity" min="1" :max="product.stock">
                        <button class="quantity-btn" @click="increaseQuantity">+</button>
                    </div>
                </div>

                <div class="action-buttons">
                    <button class="wishlist-btn" style="font-size:16px;" @click="toggleWishlist">
                        Add To Cart
                    </button>
                    <button class="add-to-cart-btn" style="font-weight:bold;" @click="addToCart">
                        Buy
                    </button>
                </div>

                <div style=" border-top: 1px #b2b2b2 solid; margin-top: 30px; padding-top: 10px;">
                        <img src="../src/assets/foot/f.png" style=" width: 40px;cursor:pointer;" />
                        <img src="../src/assets/foot/x.png" style=" width: 40px; cursor: pointer;" />
                        <img src="../src/assets/foot/y.png" style=" width: 40px; cursor: pointer;" />
                </div>
            </div>
        </div>

        <!-- 商品详情选项卡 -->
        <div class="product-tabs">
            <div class="tabs-header">
                <div v-for="(tab, index) in tabs" :key="index"
                     :class="['tab', { active: currentTab === tab.id }]"
                     @click="currentTab = tab.id">
                    {{ tab.name }}
                </div>
            </div>

            <div class="tab-content">
                <div v-for="(tab, index) in tabs" :key="index"
                     :class="['tab-pane', { active: currentTab === tab.id }]">
                    <div v-if="currentTab === 'details'">
                        <div v-html="product.detail" style=" white-space: pre-wrap; "></div>
                    </div>
                </div>
            </div>
        </div>

    </main>
</template>

<script>
    export default {
        name: 'Product',
        data() {
            return {
                currentImage: '',
                selectedColor: null,
                selectedSize: null,
                quantity: 1,
                inWishlist: false,
                currentTab: 'details',
                tabs: [
                    { id: 'details', name: 'Détail' },
                ],
                productData:[],
                product: {
                   
                }
            }
        },
        mounted() {
            this.loadData();
        },
        methods: {
            async loadData() {
                try {
                    const response = await fetch('/products.json'); // 注意路径应为相对于public文件夹的路径，或者使用绝对路径如`/data/file.json`
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    const data = await response.json();

                    this.productData=data;
                    this.product=this.productData.filter(item => item.id == this.$route.query.id)[0];

                    this.currentImage=require(`@/assets/projects/${this.product.image}.jpg`);

                           this.product.detail.replace(/\n/g, '<br>');

                    console
                    .log(this.product.detail)
                } catch (error) {
                    console.error('There has been a problem with your fetch operation:', error);
                }
            },
            increaseQuantity() {
                    this.quantity++;
            },
            decreaseQuantity() {
                if (this.quantity > 1) {
                    this.quantity--;
                }
            }
        }
    }
</script>

<style scoped>
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    }

    body {
        background-color: #fafafa;
        color: #333;
    }

    .share_v2_wrap {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }

    .share_item {
        cursor: pointer;
        height: 40px;
        width: 40px;
    }

    .container {
        padding-right: 12.4%;
        padding-left: 12.4%;
        padding-top: 0vw;
        padding-bottom: 0vw;
        margin-right: 0%;
        margin-left: 0%;
        margin-top: 2vw;
        margin-bottom: 0vw;
    }

    /* 头部导航样式 */
    .header {
        background-color: #fff;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        position: sticky;
        top: 0;
        z-index: 100;
    }

    .nav-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 80px;
    }

    .logo {
        font-size: 28px;
        font-weight: bold;
        color: #000000;
        display: flex;
        align-items: center;
    }

        .logo i {
            margin-right: 10px;
        }

    .nav-menu {
        display: flex;
        list-style: none;
    }

        .nav-menu li {
            margin: 0 15px;
        }

        .nav-menu a {
            text-decoration: none;
            color: #333;
            font-weight: 500;
            font-size: 16px;
            transition: color 0.3s;
        }

            .nav-menu a:hover {
                color: #000000;
            }

    .nav-icons {
        display: flex;
        align-items: center;
    }

        .nav-icons i {
            font-size: 20px;
            margin-left: 20px;
            color: #555;
            cursor: pointer;
            transition: color 0.3s;
        }

            .nav-icons i:hover {
                color: #000000;
            }

    /* 面包屑导航 */
    .breadcrumb {
        padding: 20px 0;
        font-size: 14px;
        color: #666;
    }

        .breadcrumb a {
            color: #666;
            text-decoration: none;
        }

            .breadcrumb a:hover {
                color: #000000;
            }

        .breadcrumb span {
            margin: 0 8px;
        }

    /* 商品详情区域 */
    .product-detail {
        display: flex;
        gap: 40px;
        margin-bottom: 60px;
        background: #fff;
        border-radius: 8px;
        padding: 30px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    .product-gallery {
        width: 50%;
    }

    .main-image {
        width: 100%;
        height: 50vh;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        border-radius: 8px;
        margin-bottom: 15px;
        cursor: zoom-in;
        transition: transform 0.3s;
        background-color: #f1f0ee;
    }

        .main-image:hover {
            transform: scale(1.02);
        }

    .thumbnail-container {
        display: flex;
        gap: 10px;
    }

    .thumbnail {
        width: 80px;
        height: 80px;
        background-size: cover;
        background-position: center;
        border-radius: 4px;
        cursor: pointer;
        opacity: 0.7;
        transition: opacity 0.3s, transform 0.3s;
    }

        .thumbnail:hover, .thumbnail.active {
            opacity: 1;
            transform: scale(1.05);
            border: 2px solid #000000;
        }

    .product-info {
        width: 50%;
        text-align: left;
    }

    .product-title {
        font-size: 28px;
        margin-bottom: 15px;
        color: #333;
    }

    .product-description {
        color: #666;
        margin-bottom: 20px;
        line-height: 1.6;
    }

    .product-price {
        display: flex;
        align-items: center;
        margin-bottom: 25px;
    }

    .current-price {
        font-size: 32px;
        font-weight: bold;
        color: #000000;
        margin-right: 15px;
    }

    .original-price {
        font-size: 20px;
        text-decoration: line-through;
        color: #999;
    }

    .discount-badge {
        background: #000000;
        color: white;
        padding: 5px 10px;
        border-radius: 4px;
        font-size: 14px;
        margin-left: 15px;
    }

    .color-options {
        display: flex;
        gap: 10px;
        margin-bottom: 20px;
    }

    .color-option {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        cursor: pointer;
        border: 2px solid transparent;
        transition: transform 0.3s;
    }

        .color-option:hover, .color-option.active {
            transform: scale(1.1);
            border-color: #000000;
        }

    .size-options {
        display: flex;
        gap: 10px;
        margin-bottom: 25px;
    }

    .size-option {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #ddd;
        border-radius: 4px;
        cursor: pointer;
        transition: border-color 0.24s ease, background-color 0.24s ease, color 0.24s ease;
    }

        .size-option:hover, .size-option.active {
            border-color: #000000;
            background: #f9f0f5;
            color: #000000;
        }

    .quantity-selector {
        display: flex;
        align-items: center;
        margin-bottom: 25px;
    }

    .quantity-label {
        margin-right: 15px;
        color: #666;
    }

    .quantity-controls {
        display: flex;
        align-items: center;
        border: 1px solid #ddd;
        border-radius: 4px;
    }

    .quantity-btn {
        width: 40px;
        height: 40px;
        background: #f8f8f8;
        border: none;
        font-size: 18px;
        cursor: pointer;
        transition: background 0.3s;
    }

        .quantity-btn:hover {
            background: #000000;
            color: white;
        }

    .quantity-input {
        width: 60px;
        height: 40px;
        border: none;
        text-align: center;
        font-size: 16px;
    }

    .action-buttons {
        display: flex;
        gap: 15px;
    }

    .add-to-cart-btn {
        flex: 1;
        background: #000000;
        color: white;
        border: none;
        padding: 15px 0;
        border-radius: 4px;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        transition: background 0.3s;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
    }

        .add-to-cart-btn:hover {
            background: #433c40;
        }

    .wishlist-btn {
        flex: 1;
        background: #f8f8f8;
        border: 1px solid #ddd;
        border-radius: 4px;
        font-size: 20px;
        cursor: pointer;
        transition: border-color 0.24s ease, color 0.24s ease;
    }

        .wishlist-btn:hover {
            color: #000000;
            border-color: #000000;
        }

    /* 商品详情选项卡 */
    .product-tabs {
        margin-bottom: 60px;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    .tabs-header {
        display: flex;
        border-bottom: 1px solid #eee;
    }

    .tab {
        padding: 20px 30px;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        transition: color 0.3s;
        position: relative;
    }

        .tab:hover {
            color: #000000;
        }

        .tab.active {
            color: #000000;
        }

            .tab.active:after {
                content: '';
                position: absolute;
                bottom: -1px;
                left: 0;
                width: 100%;
                height: 3px;
                background: #000000;
            }

    .tab-content {
        padding: 30px;
    }

    .tab-pane {
        display: none;
    }

        .tab-pane.active {
            display: block;
        }

    .specs-table {
        width: 100%;
        border-collapse: collapse;
    }

        .specs-table tr {
            border-bottom: 1px solid #eee;
        }

        .specs-table td {
            padding: 15px 10px;
        }

            .specs-table td:first-child {
                width: 150px;
                color: #666;
                font-weight: 500;
            }

    /* 评价区域 */
    .review {
        border-bottom: 1px solid #eee;
        padding: 20px 0;
    }

        .review:last-child {
            border-bottom: none;
        }

    .review-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
    }

    .reviewer {
        font-weight: 500;
    }

    .review-date {
        color: #999;
        font-size: 14px;
    }

    .rating {
        color: #ffc107;
        margin-bottom: 10px;
    }

    .review-content {
        color: #666;
        line-height: 1.6;
    }

    /* 推荐商品区域 */
    .recommended-section {
        margin-bottom: 60px;
    }

    .section-title {
        font-size: 24px;
        margin-bottom: 30px;
        padding-bottom: 15px;
        border-bottom: 2px solid #000000;
        color: #333;
    }

    .products-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 20px;
    }

    .product-card {
        background: #fff;
        border-radius: 8px;
        overflow: hidden;
        transition: transform 0.3s, box-shadow 0.3s;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

        .product-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
        }

    .product-image {
        height: 200px;
        background-size: cover;
        background-position: center;
        position: relative;
    }

    .product-tag {
        position: absolute;
        top: 10px;
        right: 10px;
        background: #000000;
        color: white;
        padding: 3px 8px;
        border-radius: 4px;
        font-size: 12px;
        font-weight: bold;
    }

    .product-info-small {
        padding: 15px;
    }

    .product-name {
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 8px;
        color: #333;
        height: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .product-price-small {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .price {
        font-size: 18px;
        font-weight: bold;
        color: #000000;
    }

    .add-to-cart-small {
        background-color: #f8f8f8;
        border: none;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: background-color 0.3s;
    }

        .add-to-cart-small:hover {
            background-color: #000000;
            color: white;
        }

    /* 响应式设计 */
    @media (max-width: 992px) {
        .product-detail {
            flex-direction: column;
        }

        .product-gallery, .product-info {
            width: 100%;
        }

        .products-grid {
            grid-template-columns: repeat(3, 1fr);
        }
    }

    @media (max-width: 768px) {
        .nav-menu {
            display: none;
        }

        .products-grid {
            grid-template-columns: repeat(2, 1fr);
        }

        .container{
            margin:10px;
            padding:10px;
        }

        .action-buttons {
            flex-direction: column;
        }

        .wishlist-btn {
            width: 100%;
            height: 50px;
            padding:10px;
        }
    }

 /*   @media (max-width: 576px) {
        .products-grid {
            grid-template-columns: 1fr;
        }

        .tabs-header {
            overflow-x: auto;
            white-space: nowrap;
        }

        .thumbnail-container {
            overflow-x: auto;
            padding-bottom: 10px;
        }
    }*/
</style>
